import { useEffect } from 'react';

import { NextPage } from 'next';

import { Bark } from '~/components/Bark';
import { SeoOverrides } from '~/components/Seo/SeoOverrides';
import { Events } from '~/constants/events';
import { ExistingPartner } from '~/constants/partner';
import { trackEvent } from '~/helpers/analytics';
import AuthHelpers from '~/helpers/auth';
import Config from '~/lib/config';

const BarkPage: NextPage = () => {
  useEffect(() => {
    AuthHelpers.setCookie({
      name: 'partner',
      value: ExistingPartner.bark,
      numDaysActive: 30,
    });

    trackEvent({ name: Events.BarkPartnerPageViewed });
  }, []);

  return (
    <>
      <SeoOverrides
        openGraph={{
          url: `${Config.SITE}/bark`,
          title: 'You can finally talk to your dog - in their language.',
          description:
            'BARK has teamed up with the language learning browser extension, Toucan, to help you learn how to bark to your furry friend. Try it out!',
          images: [{ url: `${Config.SITE}/images/bark/opengraph.png`, width: 1200, height: 630 }],
        }}
      />
      <Bark />
    </>
  );
};

export default BarkPage;
